// extracted by mini-css-extract-plugin
module.exports = {"Commands":"Commands-module__Commands___3tLEY","pencil":"Commands-module__pencil___1ZglZ","cancel":"Commands-module__cancel___3AOtU","delete":"Commands-module__delete___2OM11"};